import axios from "../axios";

const api = {
  addIndirectEmissionsItem({ questionnaireId, data, type }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.post(`/organization-questionnaires/${questionnaireId}/indirect-emissions/${type}`, data, headers)
      .then(({ data }) => data);
  },

  updateIndirectEmissionsItem({ questionnaireId, recordId, data, type }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.put(`/organization-questionnaires/${questionnaireId}/indirect-emissions/${type}/${recordId}`, data, headers)
      .then(({ data }) => data);
  },

  deleteIndirectEmissionsItem({ questionnaireId, recordId, type }, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.delete(`/organization-questionnaires/${questionnaireId}/indirect-emissions/${type}/${recordId}`,
      headers).then(({ data }) => data);
  },

  getIndirectEmissionsItems(params, accessToken) {
    const config = {
      params: params.queryParams,
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(`/organization-questionnaires/${params.questionnaireId}/indirect-emissions/${params.type}`,
      config).then(({ data }) => data);
  },
};

export default api;
